export class ReasonForLosing {
    LossingReasonsID: number;
    LossingReasonsName: string;
    LossingReasonsDescription: string;
    IsActive: boolean = true;
    ModifiedBy: number;
}